import { useFormContext, useWatch } from 'react-hook-form';

import { MAX_NUMBER_VALUE } from '@xemplo/gp-constants';
import { ChangeTaskTypes } from '@xemplo/gp-types';
import { amendmentRateUnitFieldValidation } from '@xemplo/gp-utils';
import { DawnCircleInformation } from '@xemplo/icons';
import { NumberFieldRhf, NumberFormat } from '@xemplo/number-field';
import { Colour } from '@xemplo/style-constants';
import { Tooltip, TooltipPlacement } from '@xemplo/tooltip';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

import { AmountMethodOptions } from './bulk-upload/bulk-upload.types';

export function Rate() {
  const { control } = useFormContext<FormFields>();
  const changeTask = useWatch({ control, name: 'changeTask' });
  const amountMethod = useWatch({ control, name: 'amountMethod' });

  const isTermination = changeTask === ChangeTaskTypes.TERMINATION;
  const showRateField = amountMethod !== AmountMethodOptions.Variable && !isTermination;
  const isPayInstruction = changeTask === ChangeTaskTypes.PAY_INSTRUCTION;

  if (!showRateField) return null;

  return (
    <S.FormLabel>
      <S.LabelWithTooltip>
        {isPayInstruction ? (
          <span>
            Amount
            <S.OptionalLabel>(optional) </S.OptionalLabel>
          </span>
        ) : (
          <>
            <span>
              Rate
              <S.OptionalLabel>(optional) </S.OptionalLabel>
            </span>
            <Tooltip
              text="If no rate is specified, the worker’s rate from PPS will be used."
              placement={TooltipPlacement.BottomRight}
            >
              <DawnCircleInformation height={24} width={24} color={Colour.Gray[300]} />
            </Tooltip>
          </>
        )}
      </S.LabelWithTooltip>

      <NumberFieldRhf
        aria-label="Rate field"
        name="rate"
        formatOptions={{
          numberFormat: NumberFormat.Currency,
        }}
        placeholder={isPayInstruction ? 'Enter amount' : 'Enter rate'}
        rules={{
          deps: ['recurringMaxAmount', 'units'],
          min: {
            value: 0,
            message: 'Field min value is 0',
          },
          max: {
            value: MAX_NUMBER_VALUE,
            message: `Field max value is ${MAX_NUMBER_VALUE}`,
          },
          validate: (value, { recurringMaxAmount, units }) =>
            amendmentRateUnitFieldValidation(value, units, recurringMaxAmount),
        }}
      />
    </S.FormLabel>
  );
}
